import axios from "axios";

const BASE_URL = "https://server.newslaundry.com/sponsor-subscription";

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export async function fetchSponsorshipsLeft(
  parentSubscriptionId,
  setsponsoredSubsLeft = () => {}
) {
  try {
    // console.log("chekc fetchSponsorshipsLeft", parentSubscriptionId);
    const { data } = await api.get(`/${parentSubscriptionId}/left`);
    setsponsoredSubsLeft(data?.parentSubscription?.subscriptionsLeftToSponsor);
    // console.log("chekc fetchSponsorshipsLeft", data);
    return data;
  } catch (err) {
    // setsponsoredSubsLeft
    if (
      err.response?.data?.message === "Parent subscription not found" &&
      err.response?.status === 404
    )
      setsponsoredSubsLeft(-99);
    console.log("fetchSponsorshipsLeft error", err.response?.data);
    // throw err;
  }
}

export async function createSponsoredChild(
  parentSubscriptionId,
  childEmail,
  token
) {
  try {
    console.log("çhk parent id", parentSubscriptionId, childEmail, token);

    const { data } = await api.post(`/${parentSubscriptionId}/child`, {
      childEmail,
      token,
    });

    return data;
  } catch (err) {
    console.error("createSponsoredChild error", err);
    // throw err;
  }
}

export async function fetchUserChildSubscriptions(userEmail) {
  try {
    const encoded = encodeURIComponent(userEmail);
    const { data } = await api.get(`/user/${encoded}/children`);
    return data;
  } catch (err) {
    console.error("fetchUserChildSubscriptions error", err);
    // throw err;
  }
}

export async function fetchChildrenForParent(
  parentSubscriptionId,
  setsponsoredChildren = () => {}
) {
  try {
    const { data } = await api.get(`/${parentSubscriptionId}/children`);
    // console.log("fetchChildrenForParent", data);
    setsponsoredChildren(data.children);
    return data;
  } catch (err) {
    console.error("fetchChildrenForParent error", err);
    // throw err;
  }
}

export async function fetchParentForChild(childSubscriptionId) {
  try {
    const { data } = await api.get(`/child/${childSubscriptionId}/parent`);
    return data;
  } catch (err) {
    console.error("fetchParentForChild error", err);
    // throw err;
  }
}

export default {
  fetchSponsorshipsLeft,
  createSponsoredChild,
  fetchUserChildSubscriptions,
  fetchChildrenForParent,
  fetchParentForChild,
};
